module.exports = __webpack_public_path__ + "static/img/41.094af388.png";